import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import HelpListComponent from "../components/help/HelpListComponent";
import HelpFormComponent from "../components/help/HelpFormComponent";
import HelpShowComponent from "../components/help/HelpShowComponent";

const HelpPage = (props) => {

  const {t, i18n} = props;

  useEffect(() => {
    document.title = t('control_panel') + ' - ' + process.env.REACT_APP_TITLE;
  }, []);

  return (
    <div className="HelpPage p-component p-m-lg-4">
      <div className={"p-p-3 p-p-lg-0"}>
        <Panel>
          <HelpListComponent />
        </Panel>
        <Sidebar position="right" visible={window.App.state.sidebarHelpForm} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => window.App.setState({
                   sidebarHelpForm: false,
                 })}>
          <HelpFormComponent />
        </Sidebar>
        <Sidebar position="right" visible={window.App.state.sidebarHelpShow} closeOnEscape={true}
                 style={{width: '780px'}}
                 onHide={() => window.App.setState({
                   sidebarHelpShow: false,
                 })}>
          <HelpShowComponent />
        </Sidebar>
      </div>
    </div>
  )
}
export default withTranslation('common')(HelpPage);
